import { combineReducers } from 'redux'

import display from './display'

// Application Root Reducer
export default combineReducers({
  display,
})
